module.exports = __webpack_public_path__ + "img/8.3d85fba6.png";